<template>
  <div v-if="itemListNum" class="dish-container">
    <div class="dish-header">
      <p>{{ $t('Gattaran_0509_PLgH_VDtS' /**top 10 Dishes*/) }}</p>
      <p>{{ period }}</p>
    </div>
    <div
      v-for="(item, index) in contentList"
      :key="index"
      class="dish-content"
      :class="[
        { 'dish-content-br': isBR },
        { 'dish-content-br-last': isBR && index === contentList.length - 1 },
      ]"
    >
      <template v-if="isBR">
        <div style="display: flex; justify-content: space-between; width: 100%">
          <div class="dish-title">
            <div class="dish-rank">
              <div :class="['rank-normal rank-normal-br', { 'rank-normal-br-top': index < 3 }]">
                {{ index + 1 }}
              </div>
            </div>
            <div>
              <div class="dish-name dish-name-br">{{ item.itemName }}</div>
            </div>
          </div>
          <div class="dish-sales">
            <p class="dish-sales-volumn dish-sales-volumn-br">
              {{ item.salesVolume }}
            </p>
            <p class="dish-sales-gmv dish-sales-gmv-br">{{ item.salesGmvRadio }}%</p>
          </div>
        </div>
        <div v-if="Array.isArray(item.promotionActivityList) && item.promotionActivityList.length">
          <div
            v-for="(subItem, subIndex) in item.promotionActivityList"
            :key="`${index}-${subIndex}-${subItem.title}`"
            class="dish-promotion-br"
          >
            <span class="promotion-title promotion-title-br">{{ subItem.titleDesc }}: </span>
            <span class="promotion-ratio"
              >{{ subItem.theme }} | {{ $t('FoodB_20250414_zXUI_rXee' /** 商家补贴 */) }}
              {{ subItem.rBurnRatio ? subItem.rBurnRatio + '%' : '--' }} |
              {{ $t('FoodB_20250414_faym_bhsa' /** 平台补贴 */) }}
              {{ subItem.bBurnRatio ? subItem.bBurnRatio + '%' : '--' }} |
              {{ $t('FoodB_20250414_oAyQ_liSz' /** 最终折扣 */) }}
              {{ subItem.rcBurnRatio ? subItem.rcBurnRatio + '%' : '--' }}</span
            >
          </div>
        </div>
      </template>
      <template v-else>
        <div class="dish-title">
          <div class="dish-rank">
            <div v-if="getSpecialRnk(index + 1)" class="rank-special">
              <img :src="getSpecialRnk(index + 1)" />
            </div>
            <div v-else class="rank-normal">{{ index + 1 }}</div>
          </div>
          <div>
            <div class="dish-name">{{ item.itemName }}</div>
            <div
              v-if="Array.isArray(item.promotionActivityList) && item.promotionActivityList.length"
            >
              <div
                v-for="(subItem, subIndex) in item.promotionActivityList"
                :key="`${index}-${subIndex}-${subItem.title}`"
                class="dish-promotion"
              >
                <span class="promotion-title">{{ subItem.titleDesc }}: </span>
                <span class="promotion-ratio"
                  >{{ subItem.theme }} | {{ $t('FoodB_20250414_zXUI_rXee' /** 商家补贴 */) }}
                  {{ subItem.rBurnRatio ? subItem.rBurnRatio + '%' : '--' }} |
                  {{ $t('FoodB_20250414_faym_bhsa' /** 平台补贴 */) }}
                  {{ subItem.bBurnRatio ? subItem.bBurnRatio + '%' : '--' }} |
                  {{ $t('FoodB_20250414_oAyQ_liSz' /** 最终折扣 */) }}
                  {{ subItem.rcBurnRatio ? subItem.rcBurnRatio + '%' : '--' }}</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="dish-sales">
          <p class="dish-sales-volumn">
            {{ item.salesVolume }}
          </p>
          <p class="dish-sales-gmv">{{ item.salesGmvRadio }}%</p>
        </div>
      </template>
    </div>
    <div v-if="isBR ? itemListNum >= 6 : true" class="item-view" @click="toogleCollapse">
      <p>{{ toggleText() }}</p>
      <i class="crm--chevron_down" :class="{ 'transform-icon': collapse }"></i>
    </div>
  </div>
</template>

<script>
import { getBDCountry } from '@/common/utils/i18n'
import { slice } from 'lodash'
export default {
  name: 'TopItems',
  props: {
    itemData: {
      type: Array,
      default: () => [],
    },
    period: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      collapse: true,
    }
  },
  computed: {
    isBR() {
      return getBDCountry() === 'BR'
    },
    itemListNum() {
      return this.itemData.length
    },
    contentList() {
      return this.collapse ? slice(this.itemData, 0, 5) : this.itemData
    },
  },
  methods: {
    getSpecialRnk(index) {
      const specialImgList = {
        1: require('@/pages-v2/ShopDetail/components/DiagnosisCommon/assets/img/top1.png'),
        2: require('@/pages-v2/ShopDetail/components/DiagnosisCommon/assets/img/top2.png'),
        3: require('@/pages-v2/ShopDetail/components/DiagnosisCommon/assets/img/top3.png'),
      }
      return specialImgList[index]
    },
    toggleText() {
      return this.collapse ? this.gettext('查看更多') : this.gettext('点击收起')
    },
    toogleCollapse() {
      this.collapse = !this.collapse
    },
  },
}
</script>

<style lang="scss" scped>
@import '@/common/style/mixin.scss';
.dish-promotion-br {
  background: rgba(242, 242, 245, 0.5);
  border-radius: 16px;
  padding: 16px 24px;
  margin-bottom: 16px;
  margin-left: 48px;
  font-size: 24px;
  line-height: 36px;
  .promotion-title {
    font-family: DiDiSans-Pro-Regular;
    color: #333333;
    font-weight: 400;
  }
  .promotion-title-br {
    color: #0c0c0d;
  }
  .promotion-ratio {
    font-family: DiDiSans-Pro-Regular;
    color: #8a8a91;
    font-weight: 400;
  }
}
.dish-promotion-br:last-child {
  margin-bottom: 0;
}
.dish-container {
  padding-top: 40px;
  margin-bottom: -24px;
  .dish-header {
    display: flex;
    height: 60px;
    justify-content: space-between;
    box-sizing: border-box;
    @include border-bottom-1px(#ebebeb, solid);
    p {
      font-family: DiDiSans-Pro-Regular;
      font-size: 20px;
      line-height: 60px;
      color: #999999;
      font-weight: 400;
    }
  }
  .dish-content {
    height: fit-content;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding-top: 24px;
    @include border-bottom-1px(#ebebeb, solid);
  }
  .dish-content-br {
    padding-bottom: 24px;
    flex-wrap: wrap;
  }
  .dish-content-br-last {
    &::after {
      display: none;
    }
  }
  .dish-title {
    display: flex;
    .dish-rank {
      width: 48px;
      height: 48px;
      display: flex;
      .rank-normal {
        width: 36px;
        height: 36px;
        background: #f5f5f5;
        border-radius: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: DiDiSans-Pro-Medium;
        font-size: 20px;
        color: #666666;
        text-align: center;
        line-height: 28px;
        font-weight: 500;
        margin-top: 8px;
      }
      .rank-normal-br {
        color: #0c0c0d;
        font-weight: bold;
        border-radius: 50%;
      }
      .rank-normal-br-top {
        background: #fffadb;
      }
      .rank-special {
        justify-content: center;
        align-items: center;
        img {
          width: 48px;
          height: 48px;
        }
      }
    }
    .dish-name {
      height: 48px;
      line-height: 48px;
      font-family: DiDiSans-Pro-Regular;
      font-size: 28px;
      color: #333333;
      font-weight: 400;
      margin-left: 12px;
      margin-bottom: 16px;
      overflow: hidden;
    }
    .dish-name-br {
      color: #0c0c0d;
      font-weight: 500;
    }
    .dish-promotion {
      background: rgba(242, 242, 245, 0.5);
      border-radius: 16px;
      padding: 16px 24px;
      margin-bottom: 16px;
      font-size: 24px;
      line-height: 36px;
      .promotion-title {
        font-family: DiDiSans-Pro-Regular;
        color: #333333;
        font-weight: 400;
      }
      .promotion-title-br {
        color: #0c0c0d;
      }
      .promotion-ratio {
        font-family: DiDiSans-Pro-Regular;
        color: #8a8a91;
        font-weight: 400;
      }
    }
  }
  .dish-sales {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    .dish-sales-volumn {
      font-family: DiDiSans-Pro-Medium;
      font-size: 28px;
      color: #333333;
      font-weight: 500;
      margin-bottom: 8px;
    }
    .dish-sales-volumn-br {
      color: #0c0c0d;
    }
    .dish-sales-gmv {
      font-family: DiDiSans-Pro-Regular;
      font-size: 24px;
      color: #999999;
      font-weight: 400;
    }
    .dish-sales-gmv-br {
      font-size: 20px;
      margin-bottom: 8px;
    }
  }
  .item-view {
    height: 65px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: DiDiSans-Pro-Regular;
    font-size: 24px;
    color: #666666;
    font-weight: 400;
    .transform-icon {
      transform: rotate(180deg);
    }
    .crm--chevron_down {
      font-size: 24px;
      width: 24px;
      height: 24px;
      margin-left: 16px;
    }
  }
}
</style>
